module.exports = __webpack_public_path__ + "static/media/ESS_valve.d6565ef5.jpg";